import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  searchAgreements,
  saveMeeting,
  listMeetings,
  updateMeeting,
  viewMeeting,
  getMeetingStatusOptions,
  deleteMeeting,
} from "../../../api/meeting_api";

export const searchAgreementsAction = createAsyncThunk(
  "caseMeeting/searchAgreements",
  async (payload, { rejectWithValue }) => {
    try {
      const result = await searchAgreements(payload);
      return result;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to search agreements");
    }
  },
);

export const saveMeetingAction = createAsyncThunk(
  "caseMeeting/saveMeeting",
  async (payload, { rejectWithValue }) => {
    try {
      const result = await saveMeeting(payload);
      return result;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to save meeting");
    }
  },
);

export const listMeetingsAction = createAsyncThunk(
  "caseMeeting/listMeetings",
  async (payload, { rejectWithValue }) => {
    try {
      const result = await listMeetings(payload);
      return result;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch meetings");
    }
  },
);

export const updateMeetingAction = createAsyncThunk(
  "caseMeeting/updateMeeting",
  async ({ meetingId, payload }, { rejectWithValue }) => {
    try {
      const result = await updateMeeting(meetingId, payload);
      return result;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to update meeting");
    }
  },
);

export const viewMeetingAction = createAsyncThunk(
  "caseMeeting/viewMeeting",
  async (meetingId, { rejectWithValue }) => {
    try {
      const result = await viewMeeting(meetingId);
      return result;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to load meeting");
    }
  },
);

export const getMeetingStatusOptionsAction = createAsyncThunk(
  "caseMeeting/getMeetingStatusOptions",
  async (_, { rejectWithValue }) => {
    try {
      const result = await getMeetingStatusOptions();
      return result;
    } catch (error) {
      return rejectWithValue(
        error.message || "Failed to fetch meeting status options",
      );
    }
  },
);

export const deleteMeetingAction = createAsyncThunk(
  "caseMeeting/deleteMeetingAction",
  async (meetingId, { rejectWithValue }) => {
    try {
      const result = await deleteMeeting(meetingId);
      return result;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to load meeting");
    }
  },
);
